module.exports = __webpack_public_path__ + "static/media/SPPU.03e96c60.png";